import { SalesDetail, SaleStatus, TipAdjustmentSaleFields } from "../interfaces/sales";

/**
 * Card processors that expose no refund API to the backend, so a full cancellation refunds the
 * customer by SPEI and the operator has to type the phone that receives the WhatsApp. Verifone
 * terminals (Afirme acquirer) authorize on the device itself, so they are refunded this way too.
 * Sale and bill detail both read this list; keep it here so a new processor is added once.
 */
export const SPEI_MERCHANTS: string[] = ["bankaool", "clover", "verifone"];

/**
 * Merchant the backend records on card transactions that come from an external order. Unlike the
 * terminal ones, their `paid_at` is stored in UTC, so it must be converted before showing it.
 */
export const EXTERNAL_ORDER_MERCHANT: string = "external_order";

/**
 * YOSHI-10935: payment types that are only recorded from the dashboard or the external orders API,
 * never charged at a terminal, so they are not offered as a method a user or client may charge with.
 */
export const RECORDED_ONLY_PAYMENT_TYPES: string[] = ["spei"];

/**
 * YOSHI-10935: an external order the external system sent unpaid is held as an open account
 * (Cuenta Abierta) with its app order, out of production until it is paid. Table bills are open
 * accounts too, but they always belong to a bill.
 * @param sale Sale with its status, app order and bill
 * @returns true when the sale is an external order still waiting for its payment
 */
export const isPendingExternalOrder = (sale: Pick<SalesDetail, "status" | "app_order" | "bill">): boolean => {
  return sale.status === SaleStatus.CuentaAbierta && !!sale.app_order && !sale.bill;
};

/**
 * A tip-adjustment sale is the one created to reassign a seller's tip to their primary
 * concession. The API exposes this via the sale's `type` field ("tip_adjustment"), so the
 * classification is authoritative instead of inferred from subtotal/products.
 * @param sale Sale with its `type` field
 * @returns true when the sale is a tip-adjustment sale
 */
export const isTipAdjustmentSale = (sale: TipAdjustmentSaleFields): boolean => {
  return sale.type === "tip_adjustment";
};
